<nav class="navbar navbar-light navbar-expand-xl bg-light">
	<div class="container-fluid">
		<a class="d-flex align-items-center m-1">
			<img src="assets/img/logo.png" alt="logo" class="img-fluid-custom" />
		</a>
		<button
			id="toggler-button"
			class="navbar-toggler"
			type="button"
			data-bs-toggle="collapse"
			data-bs-target="#navbarSupportedContent"
			aria-controls="navbarSupportedContent"
			aria-expanded="false"
			aria-label="Toggle navigation"
		>
			<span class="navbar-toggler-icon"></span>
		</button>
		<div class="collapse navbar-collapse" id="navbarSupportedContent">
			<ul class="navbar-nav w-75 mx-auto">
				<li
					*ngFor="let item of menuItems"
					class="row d-flex align-items-center mb-3"
					role="button"
					routerLink="{{ item.path }}"
					[routerLinkActive]="['fw-bold']"
					(click)="toggleNavbarAndDoAction(item.name)"
				>
					<span class="col-2">
						<i
							class="{{ item.iconClass }} font-size-icon custom-nav-color"
							aria-hidden="true"
						></i>
					</span>
					<span class="col">
						<a class="nav-link text-center theme-main-color">{{ item.name }}</a>
					</span>
				</li>
			</ul>
		</div>
	</div>
</nav>
